"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlgoliaActionType = void 0;
var AlgoliaActionType;
(function (AlgoliaActionType) {
    AlgoliaActionType["SET_STATUS"] = "SET_STATUS";
    AlgoliaActionType["UPDATE_QUERY"] = "UPDATE_QUERY";
    AlgoliaActionType["SET_RESULT"] = "SET_RESULT";
})(AlgoliaActionType || (AlgoliaActionType = {}));
exports.AlgoliaActionType = AlgoliaActionType;
//# sourceMappingURL=algoliaActionType.js.map